import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Reveal, CountUp } from "./motion";

const TRUST = ["Web now, mobile app soon", "Read on your device", "Free to start"];

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* soft themed glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(60% 55% at 26% 8%, hsl(var(--primary) / 0.14), transparent 70%)" }}
      />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-6 py-20 lg:grid-cols-2 lg:px-10 lg:py-28">
        <div>
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-primary-text">
              Your money, at a glance
            </span>
          </Reveal>
          <Reveal delay={0.06}>
            <h1 className="mt-6 text-5xl font-extrabold leading-[1.02] tracking-tight text-foreground sm:text-6xl lg:text-[4.2rem]">
              Understand your money — without the spreadsheet.
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">
              BudgeAI reads your bank statement into a clear picture of where your money goes — one
              glance shows a whole month, on your laptop or your phone.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Link
                to="/auth?tab=signup"
                className="rounded-full bg-primary px-7 py-3.5 text-base font-bold text-primary-foreground shadow-[var(--glow-primary)] transition-transform hover:scale-[1.03] active:scale-[0.98]"
              >
                Get started free
              </Link>
              <a
                href="#money-flow"
                className="rounded-full border border-border bg-card px-6 py-3.5 text-base font-semibold text-foreground transition-colors hover:bg-muted"
              >
                See how it works
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.24}>
            <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2">
              {TRUST.map((t) => (
                <li key={t} className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
                  <Check className="h-4 w-4 text-[#3BA776]" />
                  {t}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.15} y={32}>
          <div className="rounded-3xl border border-border bg-card p-7 shadow-xl">
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-muted-foreground">Net worth</span>
              <span className="rounded-full bg-background px-3 py-1.5 text-xs font-semibold text-foreground">September</span>
            </div>
            <div className="mt-4">
              <CountUp
                value={48250.6}
                prefix="€"
                decimals={2}
                className="text-4xl font-extrabold tracking-tight text-foreground sm:text-[2.7rem]"
              />
              <div className="mt-1.5 text-sm font-semibold text-[#3BA776]">↗ +€1,240 this month</div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3">
              <div className="rounded-2xl bg-muted/60 p-4">
                <div className="text-xs font-semibold text-muted-foreground">Income</div>
                <div className="mt-1 text-2xl font-bold text-foreground">€5,120</div>
              </div>
              <div className="rounded-2xl bg-muted/60 p-4">
                <div className="text-xs font-semibold text-muted-foreground">Spent</div>
                <div className="mt-1 text-2xl font-bold text-foreground">€3,880</div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
